import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Table } from "react-bootstrap";
import AxiosInstance from "../../../Services/AxiosInstance";
import { API_ENDPOINTS } from "../../../Services/TaskService";
import "./Taskissuepage.css";
import { useAuth } from "../../../ProtectedRoute/AppContext";
// import Multiselect from 'multiselect-react-dropdown';
import { IoMdArrowDropdown } from "react-icons/io";
import { IoMdArrowDropup } from "react-icons/io";
import Loader from "../../../DesignLayout/Loader/Loader";
function TaskIssuePage() {
  const { user } = useAuth();
  const navigate= useNavigate();
  const [tasks, setTasks] = useState([]);
  const [status, setStatus] = useState([]);
  const [priority, setPriority] = useState([]);
  const [users, setUser] = useState([]);
  // const [newstatus, setNewstatus] = useState([]); // Ensure initial state is null or object
 const [showHistory, setShowHistory] = useState(true); // State to toggle projects
 
   const [showBugs, setshowBugs] = useState(true);

  const location = useLocation();
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const { taskId } = location.state || {};
const[bug,setbugs]=useState([]);


  const date = new Date();
  const formatDateForInput = (date) => {
    const tzOffset = new Date(date).getTimezoneOffset() * 60000; // Adjust for timezone offset
    const localISOTime = new Date(date - tzOffset).toISOString();
    return localISOTime.slice(0, 16); // Remove milliseconds and 'Z'
  };
  
  const [newtask, setNewtask] = useState({
    projectTaskId: taskId,
    taskName: "",
    modifiedBy: user.userId,
    assignedToPerson: '0',
    dueDate: formatDateForInput(date), // Format for "datetime-local"
    status: '',
    priority: '',
    description: "",
    //note:"",
   Testers:"",
  });
 
  const [History, setHistory] = useState([]);
  const [newBug, setNewBug] = useState({
    bugName: "",
    projectTaskId:taskId,
    createdBy: user.userId,
    assignedTo:'0',
    dueDate: formatDateForInput(date), // Format for "datetime-local"
    status: 1,
    priority: 1,
    bugDescription: "",
    expectedDate:date,
    FilePath: "",
    note:"",
  });

  // Fetch task details and status options
  useEffect(() => {
    const fetchTaskData = async () => {console.log(taskId);
    
      try {
        const taskResponse= await AxiosInstance.get(`${API_ENDPOINTS.GET_TASKS_ONLOAD}?taskId=${taskId}`);
        setTasks(taskResponse.data.tasks || []); 
        setStatus(taskResponse.data.status || []);
        setPriority(taskResponse.data.priority || []);
        setUser(taskResponse.data.users || []);
        setbugs(taskResponse.data.bugs||[]);
        setHistory(taskResponse.data.history||[]);
        if (taskResponse.data.tasks && taskResponse.data.tasks[0]) {
          setNewtask((prev) => ({
            ...prev,
            assignedToPerson: taskResponse.data.tasks[0].assignedToPerson || "",
            Testers: taskResponse.data.tasks[0].testers || "",
          }));
        }

        console.log(taskResponse.data.tasks[0].assignedToPerson);
        
        // 
      } catch (error) {
        console.error("Error fetching task data:", error);
        toast.error("Failed to fetch task details.");
      }
    };


    fetchTaskData();
    
  }, [newtask.projectTaskId]);
  const [testerNamess, setTesterNames] = useState("");
  const [statusName, setStatusName] = useState("");
  const [priorityName, setPriorityName] = useState("");
  const [testerName, setTesterName] = useState("");
  const [DeveloperName, setDeveloperName] = useState("");
  const [Loading,setLoading]=useState(false);
  useEffect(() => {
    if (tasks.length > 0 && tasks[0]?.assignedToPerson) {
      setNewtask((prev) => ({
        ...prev,
        taskName: tasks[0].taskName,
        assignedToPerson: tasks[0].assignedToPerson,
        status: tasks[0].status,
        priority: tasks[0].priority,
        Testers: tasks?.testers?.toString(),
      }));
  
      if (Array.isArray(tasks[0]?.testers)) {
        const testerNames = tasks[0].testers
          .map((testerId) => users.find((u) => u.userId === testerId)?.userName || "Unknown")
          .filter(Boolean)
          .join(", ");
        setTesterName(testerNames || "Not Assigned");
      } else {
        const foundTester = users.find((u) => u.userId === tasks[0]?.testers);
        setTesterName(foundTester ? foundTester.userName : "Not Assigned");
      }
     
      // Find Developer Name
      const foundDeveloper = users.find((u) => u.userId === Number(tasks[0]?.assignedToPerson));
      setDeveloperName(foundDeveloper ? foundDeveloper.userName : "Not Assigned");
  
      // Find Status Name
      const foundStatus = status.find((s) => s.id === tasks[0]?.status);
      setStatusName(foundStatus ? foundStatus.name : "Unknown Status");
  
      // Find Priority Name
      const foundPriority = priority.find((p) => p.id === tasks[0]?.priority);
      setPriorityName(foundPriority ? foundPriority.name : "Unknown Priority");
    }
  }, [tasks, users, status, priority]);
  
  useEffect(() => {
    if (tasks.length > 0 && tasks[0]?.testers) {
        const firstTesterId = Array.isArray(tasks[0].testers)
            ? tasks[0].testers[0] || "" // Use first tester if array
            : tasks[0].testers || "";   // Use single tester ID if string

        setNewtask((prev) => ({ ...prev, Testers: firstTesterId }));
    }
}, [tasks]);
  
  useEffect(() => {
    if (tasks.length > 0 && tasks[0]?.assignedToPerson) {
      setNewBug((prev) => ({
        ...prev,
        assignedTo: tasks[0].assignedToPerson,
        status: tasks[0].status,  // Ensure status is set correctly
        priority: tasks[0].priority,
      }));
    }
  }, [tasks]);
  const [showBugSession, setShowBugSession] = useState(false); // Track which section to show

  // Update this in the onClick event of the "Create Bug" button
  const handleCreateBugClick = () => {
    setShowBugSession(true); // Show bug section
  };
  const [showupdatetask, setupdatetask] = useState(false); // Track which section to show

  // Update this in the onClick event of the "Create Bug" button
  const handleupdatetaskClick = () => {
    setupdatetask(true); // Show bug section
  };
  // Get status color
  const getStatusColor = (status) => {
    switch (status) {
      case "Open":
      case "1":
        return "#ffc107";
      case "InProgress":
      case "2":
        return "#198754";
      case "OnHold":
      case "3":
        return "#17a2b8";
      case "Completed":
      case "4":
        return "#28a745";
      case "ToBeTested":
      case "6":
        return "#0d6efd";
      default:
        return "#dc3545";
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "High":
      case "1":
        return "#d32121";
      case "Medium":
      case "2":
        return "#d4f004";
      case "Low":
      case "3":
        return "#04f0d1";
      case "Critical":
      case "4":
        return "#f00404";
      default:
        return "#dc3545";
    }
  };
  
  // Convert file to Base64
  const fileToBase64 = (input) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);

      if (input instanceof File || input instanceof Blob) {
        reader.readAsDataURL(input);
      } else {
        reject(
          new Error("Unsupported input type. Only File or Blob is allowed.")
        );
      }
    });
  };
  const handlefile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
  
      // Preview the image
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }

  // Handle file upload
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const base64File = await fileToBase64(file);
        setImage(base64File);
        setNewBug((prev) => ({
          ...prev,
          FilePath: base64File,
        }));
        
      } catch (error) {
        console.error("Error converting file to Base64:", error);
        toast.error("Failed to process the file.");
      }
    }
  };
  const handleModalClose = () => {
    setShowBugSession(false);
  };

  const userIds=users.filter((x)=>x.userName===tasks[0]?.assignedToPerson).map((d)=>d.userId).toString()

  const updateTask = async (event) => {
    event.preventDefault();
    if (!tasks || tasks.length === 0) {
      toast.error("Task details are not loaded.");
      return;
    }
    
    const defaultTask = tasks[0];
    // const prioritydata = priority.find((y) => y.name === defaultTask.priority);
    // const statusdata = status.find((z) => z.name === defaultTask.status);
    const userIds=users.filter((x)=>x.userName===tasks[0]?.assignedTo).map((d)=>d.userId).toString();
       
    const priorityData = priority.filter((y) => y.name === defaultTask.priority);
    const statusData = status.filter((z) => z.name === defaultTask.status);
    const mergedTask = {
      ...newtask,
      taskName: newtask.taskName || defaultTask.taskName,
      status: newtask.status || statusData ,
      priority: newtask.priority || priorityData ,

      dueDate: newtask.dueDate || defaultTask.dueDate, // Ensure proper dueDate handling
      modifiedDate: date.toISOString(),
      
      assignedToPerson: newtask.assignedToPerson || userIds , // Ensure proper assignedTo handling
      description: newtask.description || defaultTask.description,
    };
  setLoading(true);
    try {
      const response = await AxiosInstance.put(
        API_ENDPOINTS.UPDATE_TASK,
        mergedTask
      );

      if (response.data) {
        localStorage.setItem("taskuMessage",response.data.message || "Task updated successfully.");
        
        window.location.reload();
     
      } else {
       localStorage.setItem("taskuMessage","Failed to update the task.");
      }
    } catch (error) {
      // console.error("Error updating task:", error.response?.data || error);
      // console.log(mergedTask)
      return;

    }
    finally{
      setLoading(false);
    }
  };

  //  Bug selection session /////////////////////////////////////////////
  const AddBug = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {

      const formData = new FormData();
      if (image) {
        formData.append("image", image);  // Append the image file
        // formData.append("FilePath", image); // Use the image name
    } else {
        formData.append("FilePath", null); // Default value if no image is uploaded
    }

     const mergedBug={
      ...newBug,
      assignedTo:newBug.assignedTo || userIds
     }

     for (const key in mergedBug) {
      formData.append(key, mergedBug[key]);
    }

      const response = await AxiosInstance.post(API_ENDPOINTS.POST_BUG, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data) {
        localStorage.setItem("bugtMessage",response.data);
        handleModalClose();
        navigate("/bugdetails",{ state: { taskId } })
        window.location.reload();
      } else {
        toast.error(response.data);
      }
    } catch (error) {
      toast.error("Invalid Bug Details");
    }
    finally{
      setLoading(false);
    }
  };
   window.onload=()=>{
    const updatetask=localStorage.getItem("taskuMessage");
        if (updatetask) {
          toast.success(updatetask);
          localStorage.removeItem("taskuMessage"); // Clear after showing
      }
   };
  // Update dynamic input handler to ensure required fields are set
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewtask((prev) => ({
      ...prev,
      [name]: value || prev[name], // Ensure existing values are retained if input is empty
    }));
  };

  // Handle Paste (for screenshot or copied images)
  const handlePaste = async (e) => {
    const items = e.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        const blob = items[i].getAsFile();
        if (blob) {
          try {
            const base64Image = await fileToBase64(blob);
            setImage(base64Image);
            setNewBug((prev) => ({
              ...prev,
              FilePath: base64Image,
            }));
          } catch (error) {
            console.error("Error processing pasted image:", error);
            toast.error("Failed to process the pasted image.");
          }
        }
      }
    }
  };

const toggleHistory = () => {

      setShowHistory(!showHistory);
    };
  
const Bug_tasks=(bugId)=>{
navigate('/bugdetails',{state:{bugId}})
}

const getStatusName = (statusId) => {
  const statusObj = status.find((item) => item.id === statusId);
  return statusObj ? statusObj.name : "Unknown"; // Fallback to "Unknown"
};

const getPriorityName = (priorityId) => {
  const priorityObj = priority.find((item) => item.id === priorityId);
  return priorityObj ? priorityObj.name : "Unknown";
};

const getAssignedToName = (userId) => {
  const userObj = users.find((item) => item.userId === parseInt(userId));
  return userObj ? userObj.userName : "Unassigned";
};


  return (
    <div>
      <ToastContainer />
      <Loader loading={Loading}/>
      <div className="border border-1">
        <div className="d-flex bg-info text-white p-2 align-items-center justify-content-between-center">
          <div className="col-md-6">
            <h5>Task Details</h5>
          </div>
          {user &&
    (user.permission.includes(1)===true)&&(
          <div className="col-md-6 text-end">
            <button className="btn btn-primary" onClick={handleCreateBugClick}>
              Create Bug
            </button>
          </div>
          )}
        </div>
        {(!showBugSession && !showupdatetask) && (
          <form >
            <Table striped bordered hover responsive className="shadow-sm mt-3">
              <thead className="table-primary">
                <tr>
                  <th>TaskId</th>
                  <th>Task Name</th>
                  <th>Project Name</th>
                  <th>Created By</th>
                  <th>Status</th>
                  <th>Due Date</th>
                  <th>Priority</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task) => (
                  <React.Fragment key={task.projectTaskId}>
                    <tr>
                      <td>TS-{task.projectTaskId}</td>
                      <td>
                       {newtask.taskName} 
                      </td>
                      <td>{task.project}</td>
                      <td>{task.createdBy}</td>

                      <td
                        style={{
                          backgroundColor: getStatusColor(
                            newtask.status || tasks[0].status
                          ), // Use newtask.status or fallback to task.status
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                     {statusName}
  

                      </td>

                      <td>
                        {/* <input type="date" name="dueDate" id="dueDate" value={newtask.dueDate} onChange={handleInputChange} defaultValue={task.dueDate} /> */}
                       
                         { new Date(newtask.dueDate).toISOString().split("T")[0] ||  new Date(task.dueDate).toISOString().split("T")[0] || ""}
                         
                      </td>

                      <td
                        style={{
                          backgroundColor: getPriorityColor(
                            newtask.priority || task.priority
                          ), //Use newtask.status or fallback to task.status
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                      {priorityName} 
                      </td>
                    </tr>
                    <tr className="p-5">
                <td className="p-2"></td>
              </tr>
                    <tr>
                      <th className="thead table-primary">Assigned To</th>
                      <td
                        className="tdata"
                        style={{ backgroundColor: "#ebecedd7" }}
                      >
                        {DeveloperName} 

                    
                      </td>

                      <th className="table-primary">Started Date</th>
                      <td
                        className="tdata"
                        style={{ backgroundColor: "#ebecedd7" }}
                        colSpan='1'
                      >
                        {new Date(task.cratedDate).toISOString().split("T")[0]}
                      </td>
                      <th className="table-primary">Reported Date</th>
                      <td
                        className="tdata"
                        style={{ backgroundColor: "#ebecedd7" }}
                     
                      >
                        {new Date(task.reportingDate).toISOString().split("T")[0]}
                      </td>
                      <th className="thead table-primary">Testers</th>
                      <td className="tdata" style={{ backgroundColor: "#ebecedd7" }}>
     
       {testerName}
        
     
    </td>
  

                    
                    </tr>
                    <tr className="p-5">
                <td className="p-2"></td>
              </tr>
                    <tr className="mt-5" style={{ height: "60px" }}>
                      <th className="table-primary align-items-center">
                        Description
                      </th>
                      <td
                        style={{ backgroundColor: "#ebecedd7" }}
                        className=""
                        colSpan={user.role===1 ? (4):(8)}
                      >
                      {task.description}
                        
                      </td>
                      {(user.role===1)&&(
                        <>
                      <th className="table-primary">Expected Date</th>
                      <td
                        className="tdata"
                        style={{ backgroundColor: "#ebecedd7" }}
                        colSpan="2"
                      >
                        {task.expectedDate}
                      </td>
                      </>)}
                     

                    </tr>
                    {/* <tr>
                      <td colSpan="7 ">
                        <label htmlFor="note" className="fs-5">Add Note</label>
                        <input type="text" name="note" id="note" className="w-100 p-2" value={task.note}  onChange={(e)=>setNewtask({
                          ...newtask,
                          note:e.target.value
                        })}  />
                      </td>
                    </tr> */}
                    <tr>
                      <td colSpan="8">
                     
                        <button className="btn btn-warning w-100"  onClick={handleupdatetaskClick}>
                          Update Task
                        </button>
                       
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </form>
        )}
       
        {( showupdatetask && user.permission.includes(5)===true) && (
          <form onSubmit={updateTask}>
            <Table striped bordered hover responsive className="shadow-sm mt-3">
              <thead className="table-primary">
                <tr>
                  <th>TaskId</th>
                  <th>Task Name</th>
                  <th>Project Name</th>
                  <th>Created By</th>
                  <th>Status</th>
                  <th>Due Date</th>
                  <th>Priority</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task) => (
                  <React.Fragment key={task.projectTaskId}>
                    <tr>
                      <td>TS-{task.projectTaskId}</td>
                      <td>
                        <input
                          type="text"
                          value={newtask.taskName} // Use newtask first, fallback to default task
                          onChange={(e) =>
                            setNewtask((prev) => ({
                              ...prev,
                              taskName: e.target.value,
                            }))
                          }
                          name="taskName"
                          id="taskName" className="form-control"
                        
                        />
                      </td>
                      <td>{task.project}</td>
                      <td>{task.createdBy}</td>

                      <td
                        style={{
                          backgroundColor: getStatusColor(
                            newtask.status || tasks[0].status
                          ), // Use newtask.status or fallback to task.status
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                       <select
  name="status" className="form-control"
  value={newtask.status} // This should hold the selected status ID
  onChange={(e) =>
    setNewtask((prev) => ({
      ...prev,
      status: e.target.value, // Store selected status ID
    }))
  }
>
  {status.map((statusOption) => (
    <option
      key={statusOption.id}
      value={statusOption.id} // Ensure correct status ID is used
      className="text-dark"
    >
      {statusOption.name} {/* Display status name */}
    </option>
  ))}
</select>

                      </td>

                      <td>
                        {/* <input type="date" name="dueDate" id="dueDate" value={newtask.dueDate} onChange={handleInputChange} defaultValue={task.dueDate} /> */}
                        <input
                          type="date"
                          name="dueDate" className="form-control"
                          value={ new Date(newtask.dueDate).toISOString().split("T")[0] ||  new Date(task.dueDate).toISOString().split("T")[0] || ""} // Use newtask first, fallback to default task
                          onChange={(e) =>
                            setNewtask((prev) => ({
                              ...prev,
                              dueDate: e.target.value,
                            }))
                          }
                        />
                      </td>

                      <td
                        style={{
                          backgroundColor: getPriorityColor(
                            newtask.priority || task.priority
                          ), //Use newtask.status or fallback to task.status
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        <select  name="priority" className="form-control" value={newtask.priority } onChange={(e) =>setNewtask((prev) => ({
                         
                           // Use newtask first, fallback to default task
                         
                            
                              ...prev,
                              priority: e.target.value
                                // : null,
                            }))
                          }
                        >
                          {priority.map((prioritydata) => (
                            <option
                              value={prioritydata.id}
                              key={prioritydata.id}
                            >
                              {prioritydata.name}
                            </option>
                          ))}
                        </select>
                      </td>
                    </tr>
                    <tr className="p-5">
                <td className="p-2"></td>
              </tr>
                    <tr>
                      <th className="thead table-primary">Assigned To</th>
                      <td
                        className="tdata"
                        style={{ backgroundColor: "#ebecedd7" }}
                      >
                        <select name="assignedToPerson" id="assignedToPerson" className="form-control" value={newtask.assignedToPerson} onChange={(e)=>setNewtask({
                          ...newtask,
                          assignedToPerson:e.target.value 
                        })} >
                          {users.map((data)=>(
                            <option key={data.userId} value={data.userId}>{data.userName}</option>
                          ))}
                        </select>

                    
                      </td>

                      <th className="table-primary">Started Date</th>
                      <td
                        className="tdata"
                        style={{ backgroundColor: "#ebecedd7" }}
                        colSpan='2'
                      >
                        {new Date(task.cratedDate).toISOString().split("T")[0]}
                      </td>
                      <th className="table-primary">Reported Date</th>
                      <td
                        className="tdata"
                        style={{ backgroundColor: "#ebecedd7" }}
                     
                      >
                        {new Date(task.reportingDate).toISOString().split("T")[0]}
                      </td>
                      <th className="thead table-primary">Testers</th>
                      <td className="tdata" style={{ backgroundColor: "#ebecedd7" }}>
                      <select
            name="Testers"
            id="Testers"
            className="form-control"
            value={newtask.Testers} // Now properly linked
            // disabled={user.role > 2}
            onChange={(e) =>
                setNewtask((prev) => ({ ...prev, Testers: e.target.value }))
            }
        >
            <option value="">Not Assigned</option> {/* Default option */}
            {users.map((data) => (
                <option key={data.userId} value={data.userId}>
                    {data.userName}
                </option>
            ))}
        </select>
     
    </td>
  
    

                    
                    </tr>
                    <tr className="p-5">
                <td className="p-2"></td>
              </tr>
                    <tr className="mt-5" style={{ height: "60px" }}>
                      <th className="table-primary align-items-center">
                        Description
                      </th>
                      <td
                        style={{ backgroundColor: "#ebecedd7" }}
                        className=""
                        colSpan={user.role===1 ? (4):(8)}
                      >
                        <input
                          type="text"
                          name="description"
                          id="description"
                          className="text-start w-100 p-2 form-control"
                          defaultValue={task.description}
                          onChange={handleInputChange}
                        />
                      </td>
                      {(user.role===1)&&(
                        <>
                      <th className="table-primary">Expected Date</th>
                      <td
                        className="tdata"
                        style={{ backgroundColor: "#ebecedd7" }}
                        colSpan="2"
                      >
                        {task.expectedDate}
                      </td>
                      </>)}
                     

                    </tr>
                    {/* <tr>
                      <td colSpan="7 ">
                        <label htmlFor="note" className="fs-5">Add Note</label>
                        <input type="text" name="note" id="note" className="w-100 p-2" value={task.note}  onChange={(e)=>setNewtask({
                          ...newtask,
                          note:e.target.value
                        })}  />
                      </td>
                    </tr> */}
                    <tr>
                      <td colSpan="7">
                      {user &&
    (user.permission.includes(5)===true||user.role===1||user.role===2||user.role===3)&&(
                        <button className="btn btn-warning w-100" type="submit">
                          Update Task
                        </button>
                        )}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </form>
        )}
        
        {/* add bug session */}
        {(showBugSession && tasks.length>0) && (
          <form onSubmit={AddBug}>
            <Table striped bordered hover responsive className="shadow-sm mt-3">
              <thead className="table-primary">
                <tr>
                  <th>Bug Name</th>
                  <th>Task Name</th>
                  <th>Due Date</th>
                  <th>Priority</th>
                  <th >Assigned To</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="text"
                      value={newBug.bugName} // Use newBug first, fallback to default bug
                      onChange={(e) =>
                        setNewBug((prev) => ({
                          ...prev,
                          bugName: e.target.value,
                        }))
                      }
                      name="bugName"
                      id="bugName" className="form-control"
                    />
                  </td>
                  <td>
                   {tasks[0].taskName}
                  </td>

                  <td>
            
                   
                    <input
                      type="date"
                      name="dueDate" className="form-control"
                      value={ new Date(newBug.dueDate).toISOString().split("T")[0]} // Use newBug first, fallback to default bug
                      onChange={(e) =>
                        setNewBug((prev) => ({
                          ...prev,
                          dueDate: e.target.value,
                        }))
                      }
                    />
                
                  </td>

                  <td
                    style={{
                      backgroundColor: getPriorityColor(newBug.priority),
                      color: "white",
                      textAlign: "center",
                    }}
                  >
                    <select
                      name="priority" className="form-control"
                      value={newBug.priority} // Use newBug first, fallback to default bug
                      onChange={(e) =>
                        setNewBug((prev) => ({
                          ...prev,
                          priority: e.target.value,
                        }))
                      }
                    >
                      {priority.map((priorityData) => (
                        <option value={priorityData.id} key={priorityData.id}>
                          {priorityData.name}
                        </option>
                      ))}
                    </select>
                   
                  </td>
                  <td
                        className="tdata"
                        style={{ backgroundColor: "#ebecedd7" }}
                      >
                  <select name="assignedTo" id="assignedTo" className="form-control" value={ newBug.assignedTo} onChange={(e)=>setNewBug({
                          ...newBug,
                          assignedTo:e.target.value
                        })} >
                          
                          {users.map((data)=>(
                            <option key={data.userId} value={data.userId}>{data.userName}</option>
                          ))}
                        </select>
                      </td>
                </tr>
                <tr className="p-5">
                <td className="p-2"></td>
              </tr>
                <tr>
                <th className="table-primary align-items-center" colSpan="1">
                    Description
                  </th>
                  <td
                    style={{ backgroundColor: "#ebecedd7" }}
                    className=""
                    colSpan={user.role===1 ? 2 : 8 }
                  >
                    <input
                      type="text"
                      name="description"
                      id="description"
                      className="text-start form-control"
                      value={newBug.bugDescription}
                      onChange={(e) =>
                        setNewBug((prev) => ({
                          ...prev,
                          bugDescription: e.target.value,
                        }))
                      }
                    />
                  </td>
                 
                  {user.role === 1 && (
                    <>
                      <th className="table-primary">Expected Date</th>
                      <td
                        className="tdata"
                        style={{ backgroundColor: "#ebecedd7" }}
                        colSpan="2"
                      >
                        <input
                          type="date"
                          value={newBug.expectedDate}
                          name="expectedDate" className="form-control"
                          onChange={(e) =>
                            setNewBug((prev) => ({
                              ...prev,
                              expectedDate: e.target.value,
                            }))
                          }
                        />
                      </td>
                    </>
                  )}
                </tr>
                
                <tr>
                      <td colSpan="7 ">
                        <label htmlFor="note" className="fs-5">Add Note</label>
                        <input type="text" name="note" id="note" className="w-100 p-2" value={newBug.note}  onChange={(e) =>
                            setNewBug((prev) => ({
                              ...prev,
                              note: e.target.value,
                            }))
                          } />
                      </td>
                    </tr> 
                <tr>
                  <td colSpan="7">
                    {/* <div className="attach-file-container"> */}
                    <div
                      className="upload-area"
                      style={{
                        border: "2px dashed #ccc",
                        padding: "20px",
                        width: "100%",
                        textAlign: "center",
                        position: "relative",
                      }}
                      onPaste={handlePaste}
                    >
                      <h4>Attach Screenshot or File</h4>

                      <input
                        type="file"
                        accept="image/*"
                        onChange={handlefile}
                        id="file-input"
                      />

                      <div>
                        {image && (
                          <img
                            src={image}
                            alt="attached"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "300px",
                              marginTop: "10px",
                            }}
                          />
                        )}
                      </div>
                      {/* </div> */}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="7">
                    <button className="btn btn-warning w-100" type="submit">
                      Add Bug
                    </button>
                  </td>
                </tr>
              </tbody>
            </Table>
          </form>
        )}
        {/* closed bug session */}
      </div>

 <div className="mt-3">
      <div className="border border-1">
        <div
          className="d-flex bg-info p-2 text-white align-items-center"
          // onClick={toggleBugs}
        >
           <div className="col-md-6">
           <h5>Bugs Under Tasks</h5>
        </div>

        <div className="col-md-6 text-end">
       {showBugs ?(
               <IoMdArrowDropdown size={30}/>):(
       
               <IoMdArrowDropup size={30}/>)}
        </div>
         
          
           
        
        </div>
        {/* {!showBugs &&( */}
        <div className=" tb">
          {(bug.length>0 && user &&
    user.permission.includes(3)===true) ?(
          <Table
            striped
            bordered
            hover
            responsive
            className=" shadow-sm mt-3"
          >
            <thead className="table-primary ">
              <tr className="">
                <th>BugId</th>
                <th>Bug Name</th>
                <th>Description</th>
                <th>Priority</th>
              </tr>
            </thead>
            <tbody>
            {bug.map((data) => (
    <tr key={data.bugId} onClick={()=>Bug_tasks(data.bugId)}>
      <td>{data.bugId}</td>
      <td>{data.bugName}</td>
      <td>{data.bugDescription}</td>
      <td  style={{
                          backgroundColor: getPriorityColor(
                            data.priority
                          ), // Use newtask.status or fallback to task.status
                          color: "white",
                          textAlign: "center",
                        }}>{getPriorityName(data.priority)}</td>
    </tr>
  ))}
            </tbody>
          </Table>
          ):(
            <div className="text-center">
            <p>No Bugs Found Under This Task</p> 
                    </div>
          )
        }
        </div>
        {/* )} */}
      </div>
    </div>

      <div className="mt-3">
        <div className="border border-1">
          <div
            className="d-flex bg-info p-2 text-white align-items-center"
           onClick={toggleHistory}
          >
            
            <div className="col-md-6">
            <h5>Task History</h5>
        </div>

        <div className="col-md-6 text-end">
       {showHistory ?(
               <IoMdArrowDropdown size={30}/>):(
       
               <IoMdArrowDropup size={30}/>)}
        </div>
          </div>
          {!showHistory &&(
          <div className="tb">
            {History.length>0?(

          
            <Table
              striped
              bordered
              hover
              responsive
              className=" shadow-sm mt-3"
            >
              <thead className="table-primary ">
                <tr>
                  <th>Modified Date</th>
                  <th>Modified By</th>
                  <th>Updated Field</th>
                  <th>Task Name</th>
                  <th>Description</th>
                  <th>Priority</th>
                  <th>Assigned To</th>
                  <th>Due Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
              {History.map((data) => (
      <tr key={data.id}>
        <td>{new Date(data.modifiedDate).toISOString().split("T")[0]}</td>
        <td>{data.modifiedBy}</td>
        <td>{data.updatedFields}</td>
        <td>{data.taskName}</td>
        <td>{data.description}</td>
        <td style={{
                          backgroundColor: getPriorityColor(
                            data.priority
                          ), // Use newtask.status or fallback to task.status
                          color: "white",
                          textAlign: "center",
                        }}>{getPriorityName(data.priority)}</td>
        <td>{data.assignedToPerson}</td>
        <td>{data.dueDate}</td>
        <td style={{
                          backgroundColor: getStatusColor(
                            data.status
                          ), // Use newtask.status or fallback to task.status
                          color: "white",
                          textAlign: "center",
                        }}>{getStatusName(data.status)}</td>
      </tr>
    ))}
              </tbody>
            </Table>
              ):(
                <p className="text-center">No History</p>
              )}
          </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TaskIssuePage;
